import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/api/messages';

export default {
	/*
		Get list
	*/
	getList(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	/*
		Get list paginated
	*/
	getListPaginated(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/list_paginated?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	/*
		Get My List
	*/
	getMessages(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/list?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	/*
		Get inbox
	*/
	getInbox(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/inbox?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	/*
		Get details
	*/
	getDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Create
	*/
	create(params, cb, errorCb) {
		const url = endpoint;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Update
	*/
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Delete
	*/
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.delete(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Forward message
	*/
	forward(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/forward`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Set message to display
	*/
	setToDisplayLeave(id, eventId, params, cb, errorCb) {
		const url = `${endpoint}/${id}/${eventId}/display_leave`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Bulk delete
	*/
	bulkDelete(ids, cb, errorCb) {
		const params = {
			event_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/*
		Mark as read
	*/
	markAsRead(params, cb, errorCb) {
		const url = `${endpoint}/mark_as_read`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get display messages
	*/
	getDisplayedMessage(eventSlug, cb, errorCb) {
		const url = `${endpoint}/${eventSlug}/displayed`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
